const API_URL = 'https://stcit8-r0.myshopify.com/api/2025-10/graphql.json';
const TOKEN = '0bc9395b768e0f40f4c6a79f9adff7c7';

const BRAND_GREEN = '#93D500';

document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('searchInput');
  const results = document.getElementById('searchResults');

  input.addEventListener('input', async () => {
    const query = input.value.trim();
    if (!query) {
      results.innerHTML = '';
      return;
    }

    const graphqlQuery = {
      query: `
        {
          products(first: 4, query: "${query}") {
            edges {
              node {
                id
                title
                handle
                featuredImage {
                  url
                  altText
                }
                metafield(namespace: "custom", key: "user_manual") {
                  value
                }
              }
            }
          }
        }
      `
    };

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': TOKEN
        },
        body: JSON.stringify(graphqlQuery)
      });

      const data = await response.json();
      const products = (data.data && data.data.products && data.data.products.edges) || [];

      results.innerHTML = products.map(({ node }) => {
        // ===== OBTENER URL DEL MANUAL =====
        let manual = null;

        if (node.metafield?.value) {
          try {
            const parsed = JSON.parse(node.metafield.value);
            manual = parsed.url || null;
          } catch (e) {
            manual = node.metafield.value;
          }
        }

        const manualLink = manual ? (() => {
          let link = manual.trim();
          if (link.startsWith('/')) {
            link = `https://${window.location.hostname}${link}`;
          }
          return `
            <a href="${link}" target="_blank"
               style="color:${BRAND_GREEN};font-weight:bold;text-decoration:underline;display:inline-block;">
              View Manual
            </a>
          `;
        })() : '';

        const productLink = `
          <a href="/products/${node.handle}"
             style="color:${BRAND_GREEN};font-weight:bold;text-decoration:underline;display:inline-block;">
            View Product
          </a>
        `;

        // ===== CARD DE RESULTADO =====
        return `
          <div style="
            padding:12px 0;
            border-bottom:1px solid #ccc;
            display:flex;
            justify-content:center;
          ">
            <div style="
              display:flex;
              align-items:center;
              gap:10px;
              max-width:700px;
              width:100%;
            ">

              <!-- Imagen del producto -->
              <img src="${node.featuredImage?.url || ''}" 
                   alt="${node.featuredImage?.altText || ''}" 
                   style="width:40px;height:40px;object-fit:contain;">

              <!-- Texto + links -->
              <div style="
                flex:1;
                display:flex;
                flex-direction:column;
                align-items:center;
                text-align:center;
                justify-content:center;
              ">
                <a href="/products/${node.handle}" 
                   style="display:block;margin-bottom:6px;color:#000;text-decoration:none;font-weight:500;">
                  ${node.title}
                </a>

                <div style="
                  margin-top:4px;
                  display:flex;
                  gap:18px;
                  justify-content:center;
                  align-items:center;
                ">
                  ${manualLink || ''}
                  ${productLink}
                </div>
              </div>

            </div>
          </div>
        `;
      }).join('');

    } catch (err) {
      console.error('Error:', err);
      results.innerHTML = '<p style="color:red;">Error al cargar productos.</p>';
    }
  });
});
